// =============================================================================
// EvidenceWarnings — the always-visible "📚 Citations (n)" + "⚠️ Authority warnings (n)" pair for ONE
// recommendation (G16 / F-15; Vincent 2026-10-18: "recommendations should come with both citations and
// warnings"). Shared by Longevity interventions and AI Supplement Suggestions so the two cannot drift.
//
// Both buttons open the same INLINE panel: warnings first, then the evidence for this item, then the
// feature's standards. Degrades: an item with no per-item sources still opens the feature's standards.
// Styles: healist-longevity.css (.lon-evidenceRow / .lon-warnBtn), loaded globally by index.html.
// =============================================================================
import React, { useState } from 'react';
import XaiPromptPanel from './XaiPromptPanel';
import { citationCount } from '../utils/xaiHelpers';

export default function EvidenceWarnings({
  item, featureName, groupTitle, safetySources = [],
  testId = 'evidence-citations', warnTestId = 'evidence-warnings', noWarnTestId = 'evidence-no-warnings',
}) {
  const [open, setOpen] = useState(false);
  const sources = [...(Array.isArray(item?.evidence_sources) ? item.evidence_sources : []), ...safetySources];
  const warnings = Array.isArray(item?.evidence_warnings) ? item.evidence_warnings : [];
  const n = citationCount(null, featureName, sources);
  return (
    <div className="cite-inline lon-evidence" onClick={(e) => e.stopPropagation()}>
      <div className="lon-evidenceRow">
        <button type="button" className="cite-chip" data-testid={testId} aria-expanded={open}
                onClick={() => setOpen((v) => !v)}>
          <span aria-hidden="true">📚</span> {open ? 'Hide citations' : `Citations (${n})`}
        </button>
        {warnings.length > 0 ? (
          <button type="button" className="lon-warnBtn" data-testid={warnTestId} aria-expanded={open}
                  onClick={() => setOpen(true)}>
            ⚠️ Authority warnings ({warnings.length})
          </button>
        ) : (
          <span className="lon-warnBtn lon-warnBtn--none" data-testid={noWarnTestId}>No authority warnings on file</span>
        )}
      </div>
      {open && (
        <XaiPromptPanel
          featureName={featureName}
          itemCitations={sources}
          itemWarnings={warnings}
          itemTitle={item?.name || ''}
          itemGroupTitle={groupTitle}
          citationsOnly
        />
      )}
    </div>
  );
}
